<template>
    <div class="phu-grid" :style="gridStyle">
        <div
            v-for="cell in sortedSlots"
            :key="cell.id"
            class="phu-grid__cell"
            :data-slot-id="cell.id"
            :data-phu-id="phuId"
            :data-product-id="cell.product_id || ''"
            :data-fixed="locked ? '1' : '0'"
        >
            <slot :item="cell"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PhuGrid',
    props: {
        slots: { type: Array, required: true },
        columns: { type: Number, required: true },
        phuId: { type: [Number, String], required: true },
        locked: { type: Boolean, default: false }
    },
    computed: {
        sortedSlots() {
            return this.slots.slice().sort((a, b) => a.position - b.position)
        },
        gridStyle() {
            return { gridTemplateColumns: `repeat(${this.columns}, minmax(0, 1fr))` }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/components/domain/phu-production/styles/tokens';

.phu-grid {
    display: grid;
    width: 100%;
    gap: $phu-gap;
    grid-auto-rows: minmax($phu-slot-min-height, auto);

    &__cell {
        @include display-flex();
        min-width: 0;
        min-height: $phu-slot-min-height;
    }
}
</style>
